import React from 'react'
import styles from './styles.module.css'
import SyntaxHighlighter from 'react-syntax-highlighter'
import { data } from './data'
import { lineStyle } from '../../constants'

const RadarChart = (props) => {
  const { isMobile } = props
  return (
    <div
      className={styles.container}
      style={{ paddingLeft: isMobile ? 3 : 20 }}
    >
      <h2>
        Radar Charts
        <a
          style={{ marginLeft: 20, fontSize: 15 }}
          target='_blank'
          href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/blob/master/docs/RadarChart/RadarChartProps.md'
          rel='noreferrer'
        >
          props table
        </a>
      </h2>
      <div style={{ marginLeft: 10, marginBottom: 100 }}>
        <h4>Minimal Radar Chart</h4>
        <div style={{ marginLeft: 10 }}>
          <p>A simple Radar chart can be made with just-</p>
          <SyntaxHighlighter
            showLineNumbers
            lineNumberStyle={lineStyle}
            language='javascript'
          >
            {data[0].code}
          </SyntaxHighlighter>
          <h5>Output-</h5>
          <img src={data[0].imgSrc} className={styles.radarOutput} alt='' />
          <h4>maxValue</h4>
          <p>
            <b>maxValue</b> is the maximum data value that the radar chart can
            render. By default, maxValue is equal to the largest item in the
            data array. <br />
            But as you can see in the above example, the largest value (at
            label6) touches the boundary of the radar chart. <br />
            To avoid this, we can manually provide the <i>maxValue</i> somewhat
            larger than the largest data value. <br />
            <br />
            In the above chart, just add{' '}
            <b>
              <i>maxValue={70}</i>
            </b>{' '}
            and the output will be-
          </p>
          <img
            src={require('../../assets/radar2.png')}
            className={styles.radarOutput}
            alt=''
          />
          <h4>labels and dataLabels</h4>
          <p>
            <b>labels</b> is an array of strings that is used to display the
            label along each axis. The number of axes (aster lines) in a radar
            chart is equal to the length of data.
            <br />
            The axes emerging outwards from the center look like an aster * so
            we can call them aster lines. <br />
            The default values of the labels are{' '}
            <i>label1, label2, label3... labelN</i> <br />
            <br />
            Just like <i>labels</i> displays the label texts for the axes,{' '}
            <b>dataLabels</b> displays the label texts at the polygon vertices.
          </p>
          <h4>labelConfig and dataLabelsConfig</h4>
          <p>
            The properties (like color, size, font etc) of labels and dataLabels
            can be controlled using the <b>labelConfig</b> and{' '}
            <b>dataLabelConfig</b> props. <br />
          </p>
          <SyntaxHighlighter
            showLineNumbers
            lineNumberStyle={lineStyle}
            language='typescript'
          >
            {`type LabelConfig = {
    fontSize?: number;
    stroke?: string; // font color
    textAnchor?: string;
    alignmentBaseline?: string;
    fontWeight?: string;
    fontFamily?: string;
};`}
          </SyntaxHighlighter>
          The properties provided in the <i>labelConfig</i> and{' '}
          <i>dataLabelConfig</i> props are applied to each of the labels. If you
          want to provide distinct properties for each label, you can use-
          <ul>
            <li>
              <b>labelConfigArray</b> <i>(array of labelConfig objects)</i>
            </li>
            <li>
              <b>dataLabelsConfigArray</b>{' '}
              <i>(array of dataLabelConfig objects)</i>
            </li>
          </ul>
          <h4>labelsPositionOffset and dataLabelsPositionOffset</h4>
          <p>
            The distance between the labels and their corresponding vertices.
            The default value is 5
          </p>
          <p>Below is an example that uses these props-</p>
          <SyntaxHighlighter
            showLineNumbers
            lineNumberStyle={lineStyle}
            language='javascript'
          >
            {data[1].code}
          </SyntaxHighlighter>
          <p>Output-</p>
          <img src={data[1].imgSrc} className={styles.radarOutput} alt='' />
          <h4>Other props</h4>
          <ul>
            <li>
              <b>noOfSections</b> is the number of cocentric polygons/circle
              that depict the number of levels in the grid. The default value is
              4.
            </li>
            <li>
              <b>hideAsterLines</b> hides the axes (Aster lines)
            </li>
            <li>
              <b>hideGrid</b> hides the grid (along with the aster lines)
            </li>
            <li>
              <b>hideLabels</b> hides the labels
            </li>
          </ul>
          <p>
            Below is an example using <i>hideGrid</i> and <i>hideLabels</i>
          </p>
          <SyntaxHighlighter
            showLineNumbers
            lineNumberStyle={lineStyle}
            language='javascript'
          >
            {data[2].code}
          </SyntaxHighlighter>
          <p>Output-</p>
          <img src={data[2].imgSrc} alt='' />
          <h4>polygonConfig</h4>
          <i>polygonConfig</i> is used to customize the properties of the
          polygon like stroke, fill, gradient, opacity, animation etc
          <SyntaxHighlighter
            showLineNumbers
            lineNumberStyle={lineStyle}
            language='typescript'
          >
            {`type PolygonConfig = {
  stroke?: string;
  strokeWidth?: number;
  strokeDashArray?: number[];
  fill?: string;
  gradientColor?: string;
  showGradient?: boolean;
  opacity?: number;
  gradientOpacity?: number;
  showDataValuesAsLabels?: boolean;
  isAnimated?: boolean;
  animationDuration?: number;
};`}
          </SyntaxHighlighter>
        </div>
        <hr />
      </div>
    </div>
  )
}

export default RadarChart
